export const DB_DATE_FORMAT = "YYYY-MM-DD";
export const DB_TIME_FORMAT = "H:mm";
export const DEFAULT_TIME_FORMAT = "h:mm a";
export const DEFAULT_DATE_FORMAT = "MM/DD/YYYY";
export const DEFAULT_DATETIME_FORMAT = `${DEFAULT_DATE_FORMAT} ${DEFAULT_TIME_FORMAT}`;
export const DEFAULT_TIMEZONE = "America/Los_Angeles";
export const WENT_WRONG = "Something went wrong. Please try again later.";
export const COMB_LOGO_SRC = "/comb.svg";
export const LOGO_SRC = "/logo.png";